const getRoleOfUserInWedding = (userWeddings, currentWedding) => {
  if (!userWeddings) return null;
  const correctWedding = userWeddings.filter(wedding => wedding.w.substring(6) === currentWedding);
  return correctWedding.length === 0 ? null : correctWedding[0].r;
};

export default getRoleOfUserInWedding;
